import { render } from "./edit-waitlist.vue?vue&type=template&id=1c28e850&scoped=true"
import script from "./edit-waitlist.vue?vue&type=script&lang=js"
export * from "./edit-waitlist.vue?vue&type=script&lang=js"

import "./edit-waitlist.vue?vue&type=style&index=0&id=1c28e850&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c28e850"]])

export default __exports__